<template>

  <ModalAddUsuario :isVisible="isVisibleModalAddUser" @close="isVisibleModalAddUser = false"></ModalAddUsuario>

  <ModalEditUsuario :usuario="usuarioEdit" :isVisible="isVisibleModalEditUser" @close="isVisibleModalEditUser = false">
  </ModalEditUsuario>


  <div class="d-flex">

    <NavBarLeft path="/usuarios"></NavBarLeft>

    <div class="flex-1">

      <HeaderPage title="Usuários" subtitle="Gerenciamento de usuários"></HeaderPage>

      <div class="m-2 p-2 bg-white">
        <div class="mb-2 text-end d-flex gap-1 justify-content-end">

          <ButtonField @click="isVisibleModalAddUser = true" icon="ri-add-line" type="success" size="small"
            text="Adicionar Usuário"></ButtonField>

        </div>

        <BaseTable :columns="dataTableHead" :rows="usuariosStore.usuarios" :paginationOptions="{ perPage: 50 }">

          <template #table-row="{ column, row }">

            <!-- Coluna de Ações -->
            <template v-if="column.field == '__actions'">

              <span>
                <DropdownFloating v-model:shown="row.dropdownShown" :distance="6" placement="left-start">

                  <div class="">
                    <i class="ri-more-fill cursor-pointer"></i>
                  </div>


                  <template #popper>
                    <div class="p-2 d-flex gap-2 flex-column">

                      <OptionActionDataTable @click="openModalEditUsuario(row)" text="Editar" icon="ri-pencil-line">
                      </OptionActionDataTable>

                      <OptionActionDataTable @click="deletarUsuario(row)" text="Deletar" icon="ri-delete-bin-line"
                        textColor="danger">
                      </OptionActionDataTable>

                    </div>
                  </template>
                </DropdownFloating>
              </span>

            </template>

            <!-- Colunas de status -->
            <template v-else-if="column.field == 'status'">
              <BadgeField v-if="row.status == 'active'" type="success" text="Ativo" :rounded="true">
              </BadgeField>
              <BadgeField v-else-if="row.status == 'inactive'" type="warning" text="Inativo" :rounded="true">
              </BadgeField>
            </template>

            <!-- Colunas de root -->
            <template v-else-if="column.field == 'root'">
              <BadgeField v-if="row.root" type="success" text="Sim" :rounded="true">
              </BadgeField>
              <BadgeField v-else type="danger" text="Não" :rounded="true">
              </BadgeField>
            </template>

            <!-- Colunas de parceria -->
            <template v-else-if="column.field == 'parceria'">
              {{ (row.parceria) ? row.parceria.nome : '-' }}
            </template>

            <!-- Colunas normais -->
            <template v-else>
              {{ row[column.field] }}
            </template>
          </template>

        </BaseTable>

      </div>

    </div>

  </div>
</template>


<script>
import ModalAddUsuario from '@/components/modais/ModalAddUsuario.vue';
import ModalEditUsuario from '@/components/modais/ModalEditUsuario.vue';
import { toast } from 'vue3-toastify'

import { useUsuariosStore } from '@/stores/usuarios.js'


export default {
  name: 'UsuariosPage',
  data() {
    return {

      dataTableHead:
        [
          { label: 'Id', field: 'id', tdClass: 'td-vertical-middle' },
          { label: 'Nome', field: 'nome', tdClass: 'td-vertical-middle' },
          { label: 'Parceria', field: 'parceria', tdClass: 'td-vertical-middle' },
          { label: 'E-mail', field: 'email', tdClass: 'td-vertical-middle' },
          { label: 'Root', field: 'root', sortable: false, tdClass: 'td-vertical-middle' },
          { label: 'Ações', field: '__actions', sortable: false, tdClass: 'td-actions td-vertical-middle text-center' }
        ]
      ,

      isVisibleModalAddUser: false,
      isVisibleModalEditUser: false,
      usuarioEdit: {},

      usuariosStore: useUsuariosStore()

    }
  },
  methods: {
    openModalEditUsuario(usuario) {
      usuario.dropdownShown = false
      this.usuarioEdit = usuario
      this.isVisibleModalEditUser = true
    },
    deletarUsuario(usuario) {
      this.$swal({
        title: 'Tem certeza?',
        text: `Você realmente deseja deletar esse usuário?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Cancelar',
      }).then(async (result) => {
        if (result.isConfirmed) {

          this.$notiflix.Loading.standard('Deletando Usuário')
          const result = await this.usuariosStore.delete(usuario)
          this.$notiflix.Loading.remove()

          if (result.status) {
            toast.success("Usuário deletado com sucesso")
            this.usuariosStore.get()
          } else {
            toast.error(result.message)
          }
        }
      })
    }
  },
  components: { ModalAddUsuario, ModalEditUsuario },
  mounted() {
    this.usuariosStore.get()
  }
}
</script>